module.exports = __webpack_public_path__ + "static/media/licenta29.a60fc268.png";